import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {RestangularModule, Restangular} from 'ngx-restangular';

@Injectable()
export class NavigationCompanyAssignService {

    constructor(private restangular: Restangular) {
    }

    getGroupCompany() {
        return this.restangular.one('getGroupCompany');
    }

    getUserGroupNavigation() {
        return this.restangular.one('getUserGroupNavigation');
    }

    getCompanyNavigation() {
        return this.restangular.one('getCompanyNavigation');
    }

    assignCompanyNavigation() {
        return this.restangular.all('assignCompanyNavigation');
    }

    getUserGroupByCompany() {
        return this.restangular.one('getUserGroup');

    }
}



// WEBPACK FOOTER //
// /app/src/app/services/navigation-company-assign.service.ts